import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

interface Category {
  id: string;
  name: string;
  user_id: string;
}

interface SearchAndCategoriesProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  categories: Category[];
  selectedCategoryId: string | null;
  onCategoryChange: (categoryId: string | null) => void;
}

export const SearchAndCategories = ({
  searchTerm,
  onSearchChange,
  categories,
  selectedCategoryId,
  onCategoryChange,
}: SearchAndCategoriesProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="mb-6">
      <div className="relative mb-4">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          type="text"
          placeholder={t('servicePage.searchServices')}
          value={searchTerm}
          onChange={onSearchChange}
          className="pl-10 w-full"
        />
      </div>
      
      <div className="flex items-center space-x-2 overflow-x-auto pb-2 no-scrollbar">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onCategoryChange(null)}
          className={cn(
            "whitespace-nowrap border-gray-200",
            selectedCategoryId === null 
              ? "bg-gradient-to-r from-gebeya-orange to-gebeya-pink text-white border-transparent" 
              : "bg-white text-gray-700"
          )}
        >
          {t('servicePage.allCategories')}
        </Button>
        {categories.map(category => (
          <Button
            key={category.id}
            variant="outline"
            size="sm"
            onClick={() => onCategoryChange(category.id)}
            className={cn(
              "whitespace-nowrap border-gray-200",
              selectedCategoryId === category.id 
                ? "bg-gradient-to-r from-gebeya-orange to-gebeya-pink text-white border-transparent" 
                : "bg-white text-gray-700"
            )}
          >
            {category.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
